var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRateLarg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rate_larg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46290",
    d: "M0,0H48V48H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46291",
    d: "M0,0H48V48H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6330",
    transform: "translate(6.886 7.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46292",
    d: "M20.557,30.967l8.3,5.02a2,2,0,0,0,2.98-2.16l-2.2-9.44,7.34-6.36a2,2,0,0,0-1.14-3.5l-9.66-.82L22.4,4.788a2,2,0,0,0-3.68,0l-3.78,8.9-9.66.82a2,2,0,0,0-1.14,3.5l7.34,6.36-2.2,9.44a2,2,0,0,0,2.98,2.16Z",
    transform: "translate(-3.443 -3.573)",
    fill: "#f60"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateLarg);
export default __webpack_public_path__ + "static/media/rate_larg.ecb3cbaeb64c03fb30f2519b6b85056b.svg";
export { ForwardRef as ReactComponent };